import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LOCAL_STORAGE_KEYS } from '../constants/Constants';
import './Styles/BottomNav.css';

const BottomNav: React.FC = () => {
  const [isLoggedIn] = useState(() => localStorage.getItem(LOCAL_STORAGE_KEYS.isLoggedIn) === 'true');
  const location = useLocation();

  // The account link should not be active for both /login and /settings at the same time
  const isAccountActive = location.pathname.startsWith('/settings') || location.pathname.startsWith('/login');

  return (
    <nav className="mobile-bottom-nav">
      <NavLink to="/" className="nav-btn" end>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
        <span>Home</span>
      </NavLink>
      <NavLink to="/videos" className="nav-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
        <span>Videos</span>
      </NavLink>
      <NavLink to="/about" className="nav-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
        <span>About</span>
      </NavLink>
      <NavLink to={isLoggedIn ? '/settings' : '/login'} className={`nav-btn ${isAccountActive ? 'active' : ''}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
        <span>Account</span>
      </NavLink>
    </nav>
  );
};

export default BottomNav;